export class Custodian {
	public id: string;
	public caseId: string;
	public isOrganization: boolean;
	public name: string;
	public title: string;
	public memo: string;
	public role: string;
	public address: string;
	public phone: string;
	public fax: string;
	public cell: string;
	public email: string;
	public affiliation: string;
	public customField1: string;
	public lifeCycle: number;
}
